import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { cdnURL } from 'components/utils/cdn';
import Picture from 'components/ui/picture';
import { AppStoreButton } from 'components/ui/icons';

import './styles.scss';

const IOSAppPromo = ({ className }) => {

  const iOSURL = 'https://apps.apple.com/app/birthdayalarm/id594352154?pt=405762&mt=8&ct=bday-homepage-promote';

  return (
    <div className={`ios-app-promo-container ${className}`}>
      <div className="ios-app-promo-image-1">
        <Picture
          src={cdnURL('img/rebuild/promote/ios-app/iphones-1.png')}
          has2x
          hasWebp
          alt="IOS App"
          width={342}
          height={284}
        />
      </div>
      <div className="ios-app-promo-contents">
        <p className="ios-app-promo-pretitle">NEW & IMPROVED</p>
        <h2 className="ios-app-promo-title">All new iOS app</h2>
        <p className="ios-app-promo-subtitle">Send on-the-go greetings for birthdays, holidays, anniversaries, and more!</p>
        <Link className="ios-app-promo-link" to={iOSURL} aria-label="BirthdayAlarm iOS App">
          <AppStoreButton className="app-store-button"/>
        </Link>
      </div>
      <div className="ios-app-promo-image-2">
        <Picture
          src={cdnURL('img/rebuild/promote/ios-app/iphones-2.png')}
          has2x
          hasWebp
          alt="IOS App"
          width={311}
          height={300}
        />
      </div>
      <div className="ios-app-promo-image-mobile">
        <Picture
          src={cdnURL('img/rebuild/promote/ios-app/iphones-mobile.png')}
          has2x
          hasWebp
          alt="IOS App"
          width={375}
          height={214}
        />
      </div>
    </div>
  );
}


IOSAppPromo.propTypes = {
  className: PropTypes.string,
};

IOSAppPromo.defaultProps = {
  className: ''
};

export default IOSAppPromo;
